<template>
  <div>
    <div @click="back" class="header border-bottom">
      <i class="iconfont">&#xe604;</i>
    </div>
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="list" v-for="item in alist" :key="item.id">
        <div class="detail border-bottom">
          <div class="title">
            <h5>易货产品</h5>
            <p>{{item.state}}</p>
          </div>
          <div class="product">
            <div>
              <img :src="item.changeimgUrl ? url + item.changeimgUrl : defaultimg">
            </div>
            <div>
              <h5>{{item.changetitle}}</h5>
              <p>数量：<span>{{item.changenum}}</span>件</p>
              <p>规格：<span>{{item.changespec}}</span></p>
              <span class="dollars">¥
                <span class="price"> {{item.changeprice}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="icon">
          <i class="iconfont">&#xe618;</i>
        </div>
        <div class="detail">
          <h5>需求产品</h5>
          <div class="product">
            <div>
              <h5>{{item.needtitle}}</h5>
              <p>数量：<span>{{item.neednum}}</span>件</p>
              <p>规格：<span>{{item.needspec}}</span></p>
              <span class="dollars">¥
                <span class="price"> {{item.needrpice}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多商品列表了~</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'ListList',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false,
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    fetchData () {
      this.loading = true
      this.getListInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getListInfo () {
      // 联网请求
      this.axios.get('/ApiMySupplyDemandList/GetList', {
        params: {
          id: this.$route.params.id,
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getListInfoSucc)
        .catch(this.getListInfoFail)
    },
    getListInfoSucc (res) {
      res = res.data
      var newList = this.list
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.yihuolistList))
        newList = JSON.parse(data.yihuolistList)
        if (newList.length === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            setTimeout(() => {
              if (newList[i] <= 10) {
                this.completed = true
                this.loading = false
                return
              }
              const temp = []
              for (let i = newList.length + 1; i <= newList.length + 50; i++) {
                temp.push(i)
              }
              newList = newList.concat(temp)
              this.loading = false
            }, 1000)
            this.alist.push(newList[i])
            // console.log(this.alist)
          }
        }
      }
      // console.log(newList)
    },
    getListInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.header{ padding: 10px 15px; padding-bottom: 5px;}
.header .iconfont{ font-size: 25px;}
.title{ display: flex; justify-content: space-between;}
.detail .title p{ font-size: 14px; color: #fd5a0f;}
.product{ display: flex; align-items: center;}
.detail{ padding: 10px 15px; padding-top: 0;}
.detail img{ border-radius: 5px; margin-right: 7px; width: 80px; height: 80px;}
.detail h5{ color: #000; margin-bottom: 2px;}
.detail .product h5{ font-weight: normal; color: #333;}
.detail p{ font-size: 12px; padding-top: 3px; color: #656565;}
.detail a{ text-decoration: none;}
.dollars{ display: block; padding-top: 3px; color: #fd5a0f; font-size: 12px;}
.price{ font-size: 14px;}
.list{ display: flex; flex-direction: column; padding: 15px; border-bottom: 5px solid #ececec;}
.icon{ margin: 3px; margin-left: auto; margin-right: auto;}
</style>



// WEBPACK FOOTER //
// src/pages/yihuo_list/components/List.vue